<template>
  <div class="row">
    <div class="col">
      <h1 class="shadowtext">Ultrix Platform Configuration Tool</h1>

      <img
        class="shadow"
        :src="require('@/assets/images/ultrix_ns_1ru_front.webp')"
        style="display: flex; margin: 0 auto; max-width: 1000px; width: 100%"
        alt="Ultrix FR1 frame"
      />

      <p class="front">
        <br />
        Ultrix is a state of the art platform that uses a variety of great
        technologies to provide users with a flexible, fast, and intuitive
        router that improves workflows, save costs, and provides the
        satisfaction that comes with a reliable system designed with the future
        in mind.
      </p>
      <p class="front">
        This tool enables customers to configure their own customized Ultrix
        systems for quote.
      </p>
      <br />

      <div v-if="isIE != true" class="">
        <!-- <p data-v-step="0" class="lead ">Create a new Request</p> -->
        <button class="button primary" @click="navStepOne()">
          Create a new Ultrix system</button
        ><zmdi-refresh
          v-show="isLoadingApp"
          class="spin"
          style="
            width: 2em;
            height: 2em;
            margin-bottom: -10px;
            margin-left: 1em;
          "
          aria-hidden="true"
        />
      </div>

      <div
        v-if="errors && errors.length"
        class="alert alert-danger"
        role="alert"
      >
        <ul>
          <li v-for="(error, index) of errors" v-bind:key="index">
            {{ error }}
          </li>
        </ul>
      </div>
      <hr class="mt-1" />
      <div v-if="isIE != true" class="mt-1">
        <h5>
          Your Saved Systems
          <zmdi-refresh
            v-show="isLoading"
            class="spin"
            style="margin-left: 0.4em"
            aria-hidden="true"
          />
        </h5>

        <table v-if="requests > 0" class="table requests">
          <tr
            v-for="(value, name, index) in profileData.payload.requests"
            v-bind:key="index"
            style="line-height: 35px"
          >
            <td style="font-weight: 500">
              {{ value.id }} -
              <a @click="navRequestView(value.id)">{{ value.name }}</a>
            </td>
            <td>{{ value.date }}</td>
            <td style="text-align: right">
              <button
                class="button outline white btn-sm"
                @click="navRequestView(value.id)"
              >
                Details
              </button>
            </td>
          </tr>
        </table>

        <p v-else>
          <strong>You haven't created any requests yet.</strong>
        </p>
      </div>
      <div v-else class="alert alert-danger" role="alert">
        Unfortunately Internet Explorer is not supported by this app. Please use
        another browser.
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import api from "../services/api.js";
import ZmdiRefresh from "../components/base/ZmdiRefresh.vue";
import { dataVersion } from "../store/UltrixData";

export default {
  name: "home",
  data() {
    return {
      errors: [],
      isLoadingApp: false,
    };
  },
  components: { ZmdiRefresh },
  computed: {
    isIE() {
      return this.$browserDetect.isIE;
    },
    isLoading() {
      return this.$store.state.profile.isLoading;
    },
    profileData() {
      return this.$store.state.profile.profileData;
    },
    requests() {
      return this.$store.getters["profile/getRequestCount"];
    },

    next_request_id() {
      return this.$store.getters["profile/getNextRequest"];
    },
  },
  methods: {
    navRequestView: function (id) {
      this.$root.request_id = id;
      this.$root.request_name = this.profileData.payload.requests[id].name;
      this.$router.push({ name: "requestview", params: { request_id: id } });
    },

    navStepOne: function () {
      this.isLoadingApp = true;
      this.$root.request_id = this.next_request_id;
      this.$root.request_name = "";
      this.$root.chassis_id = 1;
      this.$root.preventNav = false;
      this.$router.push("StepOne");
    },

    deleteRequest: function (id) {
      this.$store.commit("profile/deleteRequest", id);
      this.$store.dispatch("profile/saveData");
    },
    getNewToken: function () {
      // console.log("no cookie found. Getting new token..");

      api
        .getNewToken()
        .then((result) => {
          let cookieData = {
            token: result.data.token,
            version: dataVersion,
            // version: result.data.version
          };
          this.$cookies.set("RVUltrix", cookieData);
          // this.$store.commit("profile/resetProfileState");
          this.$store.commit("profile/setTokenVersion", cookieData);
          this.$root.token = result.data.token;
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log(error);
          this.$store.commit("profile/setIsLoading", false);
        });
    },
    doCookie: function () {
      /* eslint-disable no-alert, no-console */
      // check a cookie exist
      if (this.$cookies.isKey("RVUltrix")) {
        // console.log("got RVUltrix", this.$cookies.get("RVUltrix"));
        // console.log("data version:", dataVersion);
        if (this.$route.query.token) {
          this.$root.token = this.$route.query.token;
        } else {
          this.$root.token = this.$cookies.get("RVUltrix").token;
        }

        this.$store.commit("profile/setIsLoading", true);

        let localToken = this.$root.token;

        api
          .getProfile(localToken) //(this.$cookies.get("RVUltrix").token)
          .then((response) => {
            //change url in address bar if token not found
            if (response.data.token != localToken) {
              console.log(
                "profile: " + localToken + " not found. New Token:",
                response.data.token
              );
              this.$root.token = response.data.token;
              history.replaceState(null, "", "/");
            }
            // console.dir("localrespToken:" + response.data);
            this.$store.dispatch("profile/loadProfileData", response.data);

            this.$cookies.set("RVUltrix", {
              token: response.data.token,
              version: dataVersion, //response.data.version
            });

            this.$store.commit("profile/setIsLoading", false);
          })
          .catch((error) => {
            console.log("getProfile error ", error);

            this.$cookies.remove("RVUltrix");
            this.getNewToken();
            this.$store.commit("profile/setIsLoading", false);
          });

        this.$root.token = this.$cookies.get("RVUltrix").token;
      } else {
        if (this.$route.query.token) {
          this.$cookies.set("RVUltrix", { token: this.$route.query.token });
          location.replace(location.host);
        } else {
          this.getNewToken();
        }
      }
    },
    // visibilityChange(e) {
    //   console.log("document hidden", document.hidden);
    //   if (document.hidden == false) {
    //     this.showUGToast();
    //   }
    // },
  },
  created: function () {
    // this.$store.dispatch("resetStartState");
    // document.addEventListener("visibilitychange", this.visibilityChange, false);
    this.doCookie();
  },
  mounted() {
    // this.showToast();
  },
};
</script>
<style scoped>
.shadow {
  -webkit-box-shadow: 0px 10px 15px -5px rgba(0, 0, 0, 0.52);
  box-shadow: 0px 10px 15px -5px rgba(0, 0, 0, 0.52);
}
.shadowtext {
  text-shadow: -2px 2px 5px #ddd;
}
details summary {
  cursor: pointer;
}
.table-container {
  /* min-width: 100%;
   */
  width: min(100%, 750px);
  margin-left: 2rem;
}
.table.requests > tr {
  border-bottom: 1px solid var(--bg-secondary-color);
}

@media screen and (max-width: 600px) {
  .table-container {
    margin-left: 0;
    /* font-size: 0.875em; */
  }
}
details summary > * {
  display: inline;
}
.front {
  font-size: 1.8rem;
  font-weight: 500;
}
</style>
